import { render, staticRenderFns } from "./SidebarG.vue?vue&type=template&id=57a4826e"
import script from "./SidebarG.vue?vue&type=script&lang=js"
export * from "./SidebarG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports